import { useEffect, useState } from "react";

const NAV_ITEMS = [
  { id: "service", label: "サービス" },
  { id: "approach", label: "アプローチ" },
  { id: "fields", label: "対応分野" },
  { id: "cases", label: "実績" },
  { id: "pricing", label: "料金" },
  { id: "flow", label: "ご相談の流れ" },
  { id: "faq", label: "FAQ" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) {
      const y = el.getBoundingClientRect().top + window.scrollY - 72;
      window.scrollTo({ top: y, behavior: "smooth" });
    }
    setMenuOpen(false);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-6 md:px-10 lg:px-14">
        <div className="flex items-center justify-between h-[68px]">
          <a
            href="#top"
            onClick={(e) => {
              e.preventDefault();
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
            className="flex items-center gap-3 cursor-pointer"
          >
            <div className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-microscope-line text-lg"></i>
            </div>
            <div className="leading-tight">
              <div
                className={`font-heading text-[15px] tracking-[0.1em] ${
                  scrolled ? "text-foreground-900" : "text-background-50"
                }`}
              >
                原因究明研究所
              </div>
              <div
                className={`text-[10px] tracking-[0.2em] ${
                  scrolled ? "text-secondary-500" : "text-background-300"
                }`}
              >
                ROOT CAUSE LABORATORY
              </div>
            </div>
          </a>

          <nav className="hidden lg:flex items-center gap-7">
            {NAV_ITEMS.map((item) => (
              <button
                key={item.id}
                onClick={() => scrollTo(item.id)}
                className="text-sm text-foreground-700 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
              >
                {item.label}
              </button>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <button
              onClick={() => scrollTo("contact")}
              className="hidden md:inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium rounded-md transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-mail-line"></i>
              お問い合わせ
            </button>
            <button
              onClick={() => setMenuOpen((v) => !v)}
              className="lg:hidden w-10 h-10 flex items-center justify-center rounded-md text-foreground-800 hover:bg-background-200 cursor-pointer"
              aria-label="menu"
            >
              <i className={`ri-${menuOpen ? "close" : "menu"}-line text-xl`}></i>
            </button>
          </div>
        </div>

        {menuOpen && (
          <div className="lg:hidden border-t border-background-200 py-4 bg-background-50">
            <div className="flex flex-col gap-3">
              {NAV_ITEMS.map((item) => (
                <button
                  key={item.id}
                  onClick={() => scrollTo(item.id)}
                  className="text-left text-sm text-foreground-700 hover:text-primary-500 py-2 cursor-pointer"
                >
                  {item.label}
                </button>
              ))}
              <button
                onClick={() => scrollTo("contact")}
                className="mt-2 inline-flex items-center justify-center gap-2 px-5 py-2.5 bg-primary-500 text-background-50 text-sm rounded-md whitespace-nowrap cursor-pointer"
              >
                <i className="ri-mail-line"></i>
                お問い合わせ
              </button>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}